import { StyleSheet, Platform } from 'react-native';

import { pt, px } from '../../common/utils';

import { JDNativeSystem } from '@jdreact/jdreact-core-lib';

const is_ios = Platform.OS == 'ios';

const repair = JDNativeSystem.statusBarHeight;

export default StyleSheet.create({
    container: {
        width: pt(375),
        position: 'relative'
    },
    main: {
        flex: 1
    },
    // nav
    nav: {
        backgroundColor: '#fff',
        height: pt(45),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomWidth: px(1),
        borderBottomColor: 'rgb(203,203,203)',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
    },
    nav_touch: {
        position: 'absolute',
        left: 0,
        paddingHorizontal: 10,
        height: pt(45),
        justifyContent: 'center'
    },
    back_img: {
        width: 10,
        height: 17,
        alignSelf: 'center'
    },
    nav_title: {
        fontSize: 16,
        color: '#232326'
    },

    // 搜索
    top_search: {
        height: pt(45),
        backgroundColor: '#fff',
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: pt(10)
    },
    wrap_input: {
        position: 'relative',
        flex: 1
    },
    search_img: {
        position: 'absolute',
        top: pt(16),
        left: pt(20),
        height: pt(14),
        width: pt(14),
        resizeMode: 'cover'
    },
    search_input: {
        padding: 0,
        paddingLeft: pt(40),
        paddingRight: pt(20),
        fontSize: pt(12),
        backgroundColor: '#F1F3F5',
        borderRadius: pt(14),
        height: pt(28)
    },
    search_clear: {
        position: 'absolute',
        right: pt(10),
        height: pt(27),
        width: pt(25),
        justifyContent: 'center',
        alignItems: 'center'
    },
    search_cancel: {
        justifyContent: 'center',
        alignItems: 'center',
        height: pt(27)
    },
    ani_cancel: {
        overflow: 'hidden',
        flexDirection: 'row',
        justifyContent: 'center'
    },

    // label
    label: {
        flexDirection: 'row',
        backgroundColor: '#fff',
        height: pt(40),
        justifyContent: 'space-around',
        borderBottomWidth: px(1),
        borderStyle: 'solid',
        borderColor: 'rgba(0,0,0,.1)'
        // position: 'absolute',
        // top: pt(90),
        // left: 0,
        // right: 0
    },
    label_item: {
        width: '30%',
        justifyContent: 'center'
    },
    label_item_text: {
        fontSize: pt(16),
        textAlign: 'center'
    },
    label_active: {
        borderColor: '#D80815',
        borderBottomWidth: px(2),
        borderStyle: 'solid'
    },

    // 定位城市/历史访问城市/热门城市
    header_section: {
        paddingLeft: pt(10),
        paddingRight: pt(10),
        paddingTop: pt(5)
    },
    hd_title: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: pt(10)
    },
    hd_tit_txt: {
        color: 'rgb(137,137,137)',
        fontSize: pt(12)
    },
    hd_tit_line: {
        backgroundColor: 'rgba(0,0,0,.1)',
        height: px(1),
        flexGrow: 1,
        marginLeft: pt(10)
    },

    hd_wrap_city: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        width: pt(355)
    },
    hd_city_view: {
        backgroundColor: '#fff',
        borderWidth: px(1),
        borderStyle: 'solid',
        borderColor: 'rgba(0,0,0,.1)',
        borderRadius: 4,
        width: pt(80),
        height: pt(33),
        marginBottom: pt(10),
        marginRight: pt(10),
        justifyContent: 'center'
    },
    lbs_city: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    lbs: {
        marginRight: pt(5),
        width: pt(11),
        height: pt(14)
    },
    lbs_txt: {
        color: '#E2231A',
        fontSize: pt(12)
    },
    hd_city_view_con: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    hd_city_item: {
        fontSize: pt(12),
        textAlign: 'center'
    },
    max: {
        maxWidth: pt(50),
        backgroundColor: '#fff'
    },
    hd_letter_view: {
        width: pt(50)
    },
    ac_item: {
        borderColor: '#E2231A'
    },

    ac_text: {
        color: '#E2231A'
    },

    // 列表头部首字母
    list_header: {
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        height: pt(45),
        justifyContent: 'center',
        borderBottomWidth: px(1),
        borderColor: 'rgba(0,0,0,.1)'
    },
    list_header_text_wrap: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    list_hotel: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    list_item: {
        borderBottomWidth: 1,
        paddingHorizontal: pt(10),
        height: pt(44),
        paddingVertical: pt(10),
        backgroundColor: '#fff',
        borderColor: '#f3f3f3'
    },
    // 列表项
    list_item_text: {
        color: 'rgb(37,37,37)',
        fontSize: pt(14),
        height: pt(44)
    },
    list_item_text_sec: {
        color: 'rgb(137,137,137)',
        fontSize: pt(12)
    },
    list_item_text_sec_active: {
        position: 'absolute',
        right: 10,
        width: pt(19),
        height: pt(15)
    },

    // 搜索列表
    search_list: {
        // position:'absolute',
        // top:pt(45)+44+(is_ios?repair:0),
        // bottom:0,
        backgroundColor: '#fff',
        // zIndex:1,
        width: pt(375)
    },

    bottom_view: {
        height: pt(45) + 44 + 120 + (is_ios ? repair : 0) + (global.is_x ? 76 : 0)
    },

    search_item: {
        height: pt(42),
        borderBottomWidth: px(1),
        borderColor: 'rgba(0,0,0,.1)',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: pt(10)
    },
    city_text: {
        fontSize: pt(14),
        color: 'rgb(37,37,37)',
        marginRight: pt(10),
        paddingLeft: pt(10)
    },
    city_code: {
        fontSize: pt(12),
        color: 'rgb(137,137,137)'
    },
    searchValue: {
        color: '#E2231A'
    },

    // 清除按钮
    icon: {
        width: pt(15),
        height: pt(15),
        resizeMode: 'contain',
        marginRight: pt(3),
        marginTop: pt(1),
        justifyContent: 'flex-start'
    },
    clear: {
        position: 'absolute',
        paddingRight: pt(10),
        right: pt(0),
        width: pt(60)
    },

    clearbox: {
        justifyContent: 'flex-start',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    cleartxt: {
        color: '#898989'
    }
});
